import axios from 'axios';
import { StarBalance, PlatformProduct } from './types';

const baseXPUrl = import.meta.env.VITE_XP_URL;
const requestXPShopUrl = `${baseXPUrl}/fed/players/@me`;

export const getXPShopProducts = async (token: string): Promise<PlatformProduct[]> => {
  const config = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  const result = await axios.get(`${requestXPShopUrl}/redeem/options`, config);

  return result?.data;
};

export const purchaseProduct = async (name: string | null | undefined, token: string): Promise<void> => {
  const config = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  await axios.post(`${requestXPShopUrl}/providers/${name}/user-events/redeem.static`, {}, config);
};

// TODO Apply token expiring handler
export const getStarBalance = async (token: string): Promise<StarBalance> => {
  const config = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  const result = await axios.get(`${baseXPUrl}/p2e/players/@me/resources`, config);

  return result?.data;
};
